// extracted by mini-css-extract-plugin
export default {"text":"styles_text__+BAUK","required":"styles_required__64+Wq"};